// extracted by mini-css-extract-plugin
export default {"table":"Send_table__Ki6Nw","budget":"Send_budget__-CqCZ","heading":"Send_heading__fGSaa"};